"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var react_1 = require("react");
var context_1 = require("../../context");
var store_1 = require("../../store");
var styles_1 = require("../../styles");
var NumericInput_1 = __importDefault(require("./NumericInput"));
var IoIosArrowDown_1 = require("@react-icons/all-files/io/IoIosArrowDown");
var timeArr = [
    {
        text: "minutes",
        value: store_1.TimeResolution.Minutes,
    },
    {
        text: "hours",
        value: store_1.TimeResolution.Hours,
    },
    {
        text: "days",
        value: store_1.TimeResolution.Days,
    },
];
var findSelectedResolutionText = function (resolution) {
    return timeArr.find(function (t) { return t.value === resolution; }).text;
};
function TimeSelector(_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.className, className = _c === void 0 ? "" : _c, onFocus = _a.onFocus, onBlur = _a.onBlur, _d = _a.placeholder, placeholder = _d === void 0 ? "0" : _d;
    var _e = (0, react_1.useState)(false), showList = _e[0], setShowList = _e[1];
    var translations = (0, context_1.useTwapContext)().translations;
    var onTimeFormatChange = function (resolution) {
        onChange({ resolution: resolution, amount: value.amount });
        setShowList(false);
    };
    var onOpenListClick = function () {
        if (disabled)
            return;
        setShowList(true);
    };
    return ((0, jsx_runtime_1.jsxs)(StyledContainer, __assign({ className: "twap-time-selector ".concat(className), style: { pointerEvents: disabled ? "none" : "unset" } }, { children: [(0, jsx_runtime_1.jsx)(StyledInput, { children: (0, jsx_runtime_1.jsx)(NumericInput_1.default, { onBlur: onBlur, onFocus: onFocus, disabled: disabled, value: value.amount, onChange: function (v) { return onChange({ resolution: value.resolution, amount: Number(v) }); }, placeholder: placeholder }) }), (0, jsx_runtime_1.jsxs)(StyledTimeSelect, { children: [(0, jsx_runtime_1.jsxs)(StyledSelected, __assign({ onClick: onOpenListClick, className: "twap-time-selector-selected" }, { children: [(0, jsx_runtime_1.jsxs)(styles_1.StyledText, { children: [" ", translations[findSelectedResolutionText(value.resolution)]] }), (0, jsx_runtime_1.jsx)(IoIosArrowDown_1.IoIosArrowDown, {})] })), showList && ((0, jsx_runtime_1.jsx)(material_1.ClickAwayListener, __assign({ onClickAway: function () { return setShowList(false); } }, { children: (0, jsx_runtime_1.jsx)(StyledList, __assign({ className: "twap-time-selector-list" }, { children: timeArr.map(function (item) {
                                var selected = item.value === value.resolution;
                                return ((0, jsx_runtime_1.jsx)(StyledListItem, __assign({ className: "twap-time-selector-list-item ".concat(selected ? "twap-time-selector-list-item-selected" : ""), onClick: function () { return onTimeFormatChange(item.value); } }, { children: (0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: translations[item.text] }) }), item.value));
                            }) })) })))] })] })));
}
exports.default = TimeSelector;
var StyledInput = (0, system_1.styled)(system_1.Box)({
    flex: 1,
    ".twap-input": {
        input: {
            textAlign: "right",
            paddingRight: 10,
            flex: "unset",
            width: "100%",
            "&::placeholder": {
                color: "white",
            },
        },
    },
});
var StyledTimeSelect = (0, system_1.styled)(system_1.Box)({
    position: "relative",
    "& p": {
        fontSize: 14,
        fontWeight: 600,
    },
});
var StyledContainer = (0, system_1.styled)(system_1.Box)({
    display: "flex",
    alignItems: "center",
    flex: 1,
    gap: 10,
});
var StyledList = (0, system_1.styled)(system_1.Box)({
    zIndex: 99,
    position: "absolute",
    top: "-50%",
    right: -18,
    borderRadius: 20,
    padding: "11px 0px",
    width: 150,
    overflow: "hidden",
});
var StyledListItem = (0, system_1.styled)(system_1.Box)({
    padding: "0px 24px",
    textAlign: "left",
    height: 36,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    transition: "0.2s all",
    "& p": {
        fontSize: 14,
    },
});
var StyledSelected = (0, system_1.styled)(material_1.Button)({
    cursor: "pointer",
    gap: 5,
    svg: {
        width: 14,
        height: 14,
    },
});
